class BlogFilter extends HTMLElement {
  constructor() {
    super();

    // Select the <select> element within this component
    const filter = this.querySelector('select');

    if (filter) {
      filter.addEventListener('change', function () {
        const selectedValue = this.value;
        if (selectedValue) {
          window.location.href = selectedValue;
        }
      });
    }
  }
}

customElements.define('blog-filter', BlogFilter);
